export class AssertionError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, AssertionError.prototype)
  }
}

export function assert<T extends boolean>(
  predicate: T,
  message: string
): asserts predicate {
  if (predicate) {
    return
  }
  throw new AssertionError(message)
}
